<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.pending_application") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-sync"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getAffiliateList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-md-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)"
                )
              .col-md-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-md-12.col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%" v-if="!isOperator")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th(width="7%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th(@click="sortOrder('full_name')" width="7%")
                          span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                          .float-right
                            i(:class="changeSortKey('full_name')")
                        th(width="7%")
                          span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                        th(width="7%")
                          span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                        th(width="6%")
                          span(:title="$t('ui.affiliate_code')") {{ $t("ui.affiliate_code") }}
                        th.text-center(width="6%")
                          span(:title="$t('ui.verified')") {{ $t("ui.verified") }}
                        th.text-center(width="12%" v-if="showActionColumn()")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right(width="7%" @click="sortOrder('verified_date')")
                          span(:title="$t('ui.verified_date')") {{ $t("ui.verified_date") }}
                          .float-right
                            i(:class="changeSortKey('verified_date')")
                        th.text-right(width="7%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="affiliateList.length == 0")
                        td(:colspan="showActionColumn() == true ? '10' : '9'").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in affiliateList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td(v-if="!isOperator")
                          span(:title="item.operator_id") {{ item.operator_id }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.full_name") {{ item.full_name }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td
                          span(:title="item.signup_ip") {{ item.signup_ip }}
                        td
                          span(:title="item.affiliate_code") {{ item.affiliate_code }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.account_verified, 'fas fa-times text-warning': !item.account_verified  }")
                        td.text-center(v-if="showActionColumn()")
                          span(v-if="showActionButton('approveaff')")
                            a.fas.fa-check.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="onApproveAffiliate(item)" :title="$t('ui.approve')")
                          span.ml-1(v-if="showActionButton('gettacaff')")
                            a.fas.fa-mobile-alt.btn.btn-ssm.btn-secondary(href="javascript:void(0)" @click="onGetTac(item)" :title="$t('ui.get_tac')")
                        td.text-right
                          span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.verified_date") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      approveaffiliate(ref="approveaffiliate" :item="editSelectedAffiliate" @clicked="afterApproveAffiliate" @failed="handleFailed")
      gettacaffiliate(ref="gettacaffiliate" :item="editSelectedAffiliate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import approveaffiliate from "@/components/affiliate/approveAffiliate.vue";
import gettacaffiliate from "@/components/affiliate/getTacAffiliate.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    approveaffiliate,
    gettacaffiliate
  },
  data: () => ({
    loading: false,
    affiliateList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    editSelectedAffiliate: null,
    tacValidated: true,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "account_id",
    sortType: "asc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_affiliate");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted: function() {
    this.getAffiliateList(true);
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    showActionColumn() {
      return this.showActionButton('approveaff') || this.showActionButton('gettacaff');
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getAffiliateList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onApproveAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.approveaffiliate.$refs.approveAffiliate.show();
    },
    afterApproveAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.approve_affiliate"), this.$t("message.success"), "success");
    },
    onGetTac(e) {
      this.editSelectedAffiliate = e;
      this.$refs.gettacaffiliate.$refs.getTacAffiliate.show();
    },
    getAffiliateList: function(isSearch) {
      let url = config.accountListPendingAffUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list.length > 0) {
                  this.affiliateList = response.data.ds.list;
                  this.totalRow = this.affiliateList.length > 0 ? this.affiliateList[0].totalrows : 0;
                }
                else {
                  this.clearTotal()
                }
              } else {
                this.clearTotal()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.affiliateList = []
      this.totalRow = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getAffiliateList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getAffiliateList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>